// El hosting no sirve archivos .pdf (devuelve el index.html del SPA), por lo que
// los documentos se publican como JSON base64 en public/ y se reconstruyen aquí.
async function downloadPdfFromJson(jsonFileName, downloadFilename) {
  // PUBLIC_URL vale "." por el homepage del package.json, así que se ignora para
  // no resolver la ruta contra la vista actual.
  const base = process.env.PUBLIC_URL && !process.env.PUBLIC_URL.startsWith(".")
    ? process.env.PUBLIC_URL
    : "";
  const jsonUrl = `${base}/${jsonFileName}`;

  const response = await fetch(jsonUrl);
  if (!response.ok) {
    throw new Error(`No se pudo cargar ${jsonUrl}`);
  }
  const payload = await response.json();
  const binary = atob(payload.data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  const blob = new Blob([bytes], {
    type: payload.contentType || "application/pdf",
  });
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = downloadFilename || payload.filename || "documento.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}

export default downloadPdfFromJson;
